import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedBadge, setSelectedBadgeModalActive } from "../redux/data/dataSlice";
import { setupBadgeMetaData } from "../utils/metaData";
import CloseImage from "../assets/images/close.svg";
import BadgeModal from "./badges/badgeModal";
import BadgeSection from "./badges/badgeSection";
import "../assets/css/voting.css";

function Play() {
    const dispatch = useDispatch();
    const params = useParams();
    const badgeSections = useSelector(state => state.data.badgeSections);
    const selectedBadge = useSelector(state => state.data.selectedBadge);
    const selectedBadgeModalActive = useSelector(state => state.data.selectedBadgeModalActive);
    const [playSection, setPlaySection] = useState(null);

    useEffect(() => {
        const nbaNav = document.getElementById("nba-nav");
        const nbaFooter = document.getElementById("nba-footer");
        const oneTrustNba = document.getElementById("ot-sdk-btn-floating");

        if (nbaNav) {
            nbaNav.style.display = "none";
        }

        if (nbaFooter) {
            nbaFooter.style.display = "none";
        }

        if (oneTrustNba) {
            oneTrustNba.style.display = "none";
        }
    }, []);

    useEffect(() => {
        const openModal = badge => {
            dispatch(setSelectedBadge(badge));
            dispatch(setSelectedBadgeModalActive(true));
            setupBadgeMetaData(badge);
        };

        const findBadgeById = id => {
            if (id && badgeSections) {
                let foundBadge;
                for (let section in badgeSections) {
                    if (badgeSections[section].badges && badgeSections[section].badges.length > 0) {
                        foundBadge = badgeSections[section].badges.find(badge => badge.id === +id);
                        if (foundBadge) return foundBadge;
                    }
                }
            }
            return null;
        };

        if (params && params.badgeId) {
            const badge = findBadgeById(params.badgeId);

            if (badge) {
                openModal(badge);
            }
        }
    }, [params, params.badgeId, badgeSections, dispatch]);

    useEffect(() => {
        if (badgeSections["4"]) {
            const section = JSON.parse(JSON.stringify(badgeSections["4"])); // Deep Copy;
            section.name = "Badges You've Earned";
            section.desc = "Check out your NBA Play badges, and keep playing to earn the latest Player Weekly Streak badge";
            setPlaySection(section);
        }
    }, [badgeSections]);

    return (
        <>
            <div id="voting-container">
                <div
                    className="modal-close-page"
                    onClick={() => {
                        console.log("postMessage:", "badge-modal-close");
                        window.parent.postMessage({ identifier: "badge-modal-close" }, "*");
                    }}>
                    <img alt="close" src={CloseImage} style={{
                        width: "32px",
                        height: "32px",
                        float: "right",
                        margin: "15px"
                    }} />
                </div>
                {playSection && playSection.badges && playSection.badges.length > 0 && <BadgeSection section={playSection} />}
            </div>
            {selectedBadgeModalActive && selectedBadge && <BadgeModal />}
        </>
    );
}

export default Play;
